import { createModel } from '@/store/tools';

const initDataList = { dataList: [], pageNum: 1, pageSize: 30, resultTotal: 0 };
const model = {
    namespace: 'city',
    build: (T, A, S, R) => ({
        actiontypes: {
            'getCompanyCitys': T('getCompanyCitys'),
            'getCompanySele': T('getCompanySele'),
        },
        actions: {
            'getCompanyCitys': A('getCompanyCitys'),
            'getCompanySele': A('getCompanySele'),
        },
        sagas: {
            'getCompanyCitys': S('getCompanyCitys', '/?cmd=com.xqxc.api.pig.mis.biz.user.company.OperationAreaInfoMisService.findOperationAreaInfoPage'),
            'getCompanySele': S('getCompanySele', '/?cmd=com.xqxc.api.pig.mis.biz.user.company.CompanyMisService.companyItem'),
        },
        reducers: {
            'companyCitys': R('getCompanyCitys', initDataList),
            'companySele': R('getCompanySele', initDataList),
        }
    })
};
export default createModel(model);